import React, { useState } from 'react';
import { useGetAllTasksQuery } from './redux/fullApi';
import TaskItem from './TaskItem';
import { Button, List } from '@mui/material';
import TaskModal from './TaskModal';

const TaskList = () => {
  // Assuming `tasks` is the state slice where tasks are stored in your Redux store
  const { data: tasks, error, isLoading } = useGetAllTasksQuery();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
    <div
      style={{
        width: '750px',
        margin: '0 auto', // Center the list horizontally
      }}
    >
        <Button variant="contained" onClick={handleOpenModal}>
          New task
        </Button>
        <TaskModal operation="create" isOpen={isModalOpen} handleClose={handleCloseModal} />
      {!isLoading && (
        <>
          <List>
            {tasks?.map((task) => (
              <TaskItem key={task.id} task={task} />
            ))}
          </List>
        </>
      )}
    </div>
    
    </>

  );
};

export default TaskList;
